"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.array(zod_1.z.object({
    irrigationZoneId: zod_1.z.number(),
    emitterType: zod_1.z.string(),
}));
exports.path = '/irrigation-scheduler-zones-resume';
//# sourceMappingURL=index.js.map